import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchOrganizationTrainersArgs,
  FetchOrganizationTrainerById,
} from '../api/types/trainers.types';

import {
  fetchOrganizationTrainerById,
  fetchOrganizationTrainers,
} from '../api/trainers.api';

export const trainersQueryKeys = createQueryKeys('trainers', {
  fetchInfiniteOrganizationTrainers: ({
    filters,
    organizationId,
  }: FetchOrganizationTrainersArgs) => ({
    queryFn: (context) =>
      fetchOrganizationTrainers({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        organizationId,
      }),
    queryKey: [organizationId, filters],
  }),
  fetchOrganizationTrainerById: ({
    id,
    organizationId,
  }: FetchOrganizationTrainerById) => ({
    queryFn: () => fetchOrganizationTrainerById({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchOrganizationTrainers: ({
    filters,
    organizationId,
  }: FetchOrganizationTrainersArgs) => ({
    queryFn: () =>
      fetchOrganizationTrainers({
        filters,
        organizationId,
      }),
    queryKey: [organizationId, filters],
  }),
});
